import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const eodReportRoutes = [
  {
    path: '/eod-report',
    name: Routes.EODReport,
    component: () => import('@/pages/contexts/portal/eod-report/Index.vue'),
    meta: {
      pageTitle: 'EOD Report',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
        Middleware.ADD_CURRENT_DATE_QUERY_PARAM,
      ],
      anyPermissions: [
        AppPermissions.VIEW_END_OF_DAY_REPORTS,
        AppPermissions.MANAGE_EOD_REPORTS,
      ],
    },
  },
]
